module.exports = __webpack_public_path__ + "static/media/renzheng.c707bf68.svg";